/* eslint-disable react-hooks/exhaustive-deps */
import React  from "react";
import { useSelector } from "react-redux";
import "../../scss/Components/_UnlockPointsLuxury.scss";

const UnlockPointsLuxury = () => {
    const staticPointsData = useSelector(
        (state) => state.staticPointsReducer?.data
    );
    const updatedStaticPoints = Array.isArray(staticPointsData)
        ? staticPointsData.map((item, index) => ({
            ...item,
        }))
        : [];

    return (
        updatedStaticPoints?.length > 0 && (
            <section className="unlock-points-luxury-section">

                <div className="container">
                    <div className="unlock-points-list">
                        {updatedStaticPoints.map((item, index) => (

                            <div
                                key={index}
                                className="unlock-point-item"
                            >

                                <div className="unlock-icon-wrapper">
                                    <img
                                        src={`${process.env.REACT_APP_CLIENT_URL}${item.icon}`}
                                        alt={item.sub_Title}
                                        className="unlock-icon"
                                    />
                                </div>

                                <div className="unlock-content">
                                    <h6 className="unlock-title">{item.title}</h6>

                                    <p className="unlock-subtitle">
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div >
            </section >

        )
    )
}
export default UnlockPointsLuxury;
